import { map, tap } from 'rxjs/operators';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { MyLogger } from 'src/shared/services/helpers/logging.service';

export class TimingInterceptor extends MyLogger implements HttpInterceptor {
  constructor() {
    super('TimingInterceptor');
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const started = Date.now();
    // console.log('req', req);
    return next.handle(req).pipe(
      map(response => {
        // let newResponse = response;
        // console.log(response);
        if (response instanceof HttpResponse && !environment.disableLogs) {
          const elapsed = Date.now() - started;
          // Todo add loger service
          if (req.url.includes('/api/')) {
            const splitted = req.url.split('/api/');
            // console.log(splitted);
            if (splitted[1]) {
              const requestName = `${ req.method } - /api/${ splitted[1] }`;
              if (response.body) {
                this.info(`${ requestName } took ${ elapsed } ms.`, response.body);
              }
            }

          }
        }
        return response;
      })
    );
  }
}
